import Typography from '@mui/material/Typography';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { Tooltip } from '../Tooltip/Tooltip';

const ColorBox = styled(Box)<{ color: string }>(({ theme, color }) => {
  return {
    height: theme.spacing(12),
    width: theme.spacing(12),
    backgroundColor: color,
    borderRadius: theme.spacing(2),
  };
});

type GraphsColorLegendProps = {
  legendItems?: { color: string; description: string }[];
  asTooltip?: boolean;
};

export const Legend: React.FC<GraphsColorLegendProps> = ({ legendItems = [], asTooltip }) => {
  return (
    <Box
      sx={{ display: 'flex', gap: 12, flexDirection: asTooltip ? 'column' : 'row' }}
      data-testid="chart-legend"
    >
      {legendItems.map((item) => (
        <Box
          key={`${item.color}-${item.description}`}
          sx={{ display: 'flex', alignItems: 'center' }}
        >
          <ColorBox color={item.color} />
          <Typography variant="text3" color="text.secondary" ml={4} mb={2}>
            {item.description}
          </Typography>
        </Box>
      ))}
    </Box>
  );
};

export const GraphsColorLegend = ({ legendItems = [], asTooltip }: GraphsColorLegendProps) => {
  if (asTooltip) {
    return (
      <Tooltip title="" component={<Legend legendItems={legendItems} asTooltip />}>
        <Box sx={{ display: 'flex', gap: 2 }}>
          {legendItems.map((item) => (
            <ColorBox color={item.color} key={item.color} />
          ))}
        </Box>
      </Tooltip>
    );
  }

  return <Legend legendItems={legendItems} />;
};
